
<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @calculate="paasCalculate"
      ref="wrapperList" >
      <Form class="list-query-wrap"
            slot="query"
            :model="queryParam"
            :label-width="defaultLabelWidth"
            ref="queryForm"
            :label-colon="true">

        <row class="list-query-row">
          <FormItem label="分类"
                    class="list-query-item ivu-col-span-8"
                    v-clickoutside="handlefkaStoreCategoryNameClose">
            <Input v-model="queryParam.fkaStoreCategoryName" @on-focus="changefkaStoreCategoryNameFlag"
                   @on-clear="clearfkaStoreCategoryName" clearable  readonly="readonly"  style="width:300px;"></Input>
            <select-tree @selected-tree-value="updatefkaStoreCategoryNameTreeNode"  serviceUrl='/eb/store/category' v-show="showfkaStoreCategoryNameTree"/>
          </FormItem>
          <FormItem label="商品名称" class="list-query-item ivu-col-span-8">
            <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                    @on-change="queryTableDatas" clearable />
          </FormItem>
          <FormItem label="货号" class="list-query-item ivu-col-span-8">
              <Input  v-model="queryParam.query_LIKE_productNo" placeholder=""
                      @on-change="queryTableDatas" clearable />
          </FormItem>
        </row>
        <row class="list-query-row">
          <FormItem label="商品类型" class="list-query-item ivu-col-span-12">
            <ButtonGroup>
              <Button :type="queryParam.query_LIKE_isShow == ''? 'primary':'default'" @click.native="checkProduct('')">全部商品</Button>
              <Button :type="queryParam.query_LIKE_isShow == '1'? 'primary':'default'" @click.native="checkProduct('1')">出售中的宝贝</Button>
              <Button :type="queryParam.query_LIKE_isShow == '0'? 'primary':'default'" @click.native="checkProduct('0')">仓库中的宝贝</Button>
            </ButtonGroup>
          </FormItem>
        </row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
  </div>
</template>
<script>
  import wrapperList from "@/components/paas/wrapper-list";
  import metaList from "@/assets/js/list/meta-list.js";
  import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
  import CellBar from '@/components/paas/cell-bar' //列表内操作
  import SelectTree from '@/components/paas/selectTree'; //下拉树查询
  export default {
    name: "list",
    mixins: [ metaList ],
    components: { wrapperList,EnumShow  ,CellBar,SelectTree},
    data() {
      return {
        serviceUrl:"/eb/store/product",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          fkaStoreCategoryName:'',
          query_LIKE_fkaStoreCategoryId:'',
          query_LIKE_name:'',
          query_LIKE_productNo:'',
          queryOrderBy_:'createTime@DESC',
          query_LIKE_id:'',
          query_LIKE_isShow:"",
        },
        defaultLabelWidth:80,
        tableColumns:[
          {
            title: '货号',
            key: 'productNo',
            width:130,
          },
          {
            title: '商品标题',
            key: 'mainImage',
            render:(h,params)=>{
              return h("div",{
                style:{
                  display:"flex",
                  flexFlow: "row nowrap",
                  justifyContent:"space-between"
                }
              },[
                h('img',{
                  attrs: {
                    src: params.row.mainImage,
                  },
                  style:{
                    width:"80px",
                    height:"80px",
                  }
                }),
                h("div",{
                  style:{
                    margin:"2px 5px",
                    lineHeight:"20px"
                  }
                },[
                  h('p',{
                    style:{
                      fontSize:"12px",
                      color:"black",
                    }
                  },params.row.name),
                  h('p',{
                    style:{
                      fontSize:"12px",
                      marginTop:"4px",
                    }
                  },[

                  ])
                ])
              ])
            }
          },
          /*{
            title: '产品名称',
            key: 'name',
            render:(h,params)=>{
              return h("div",[
                h('p',params.row.name),
                h('p',"价格："+params.row.price),
                h('p',"分类："+params.row.fkaStoreCategoryName),
                h('p',"访客量："+params.row.browse),
                h('p',"浏览量："+params.row.browse)
              ])
            }
          },*/

          {
            title: '库存',
            key: 'stock',
            width:80
          },
          {
            title: '销量',
            key: 'sales',
            width:80
          },
          {
            title: '状态',
            key: 'isShow',
            width:100,
            render:(h,params)=>{
              return h('i-switch', {
                class:"sale-status",
                props:{
                  type: 'primary',
                  size:'large',
                  value: params.row.isShow,  //控制开关的打开或关闭状态，官网文档属性是value
                  'true-value': "1",
                  'false-value':"0",
                },
                on: {
                  'on-change': (value) => {
                    params.row.isShow = value;
                    //实时保存数据
                    this.saveOnShowData(params.row);
                  }
                }
              },[
                h('span', {
                  slot: 'open',
                  domProps: {
                    innerHTML: '上架'
                  }
                }),
                h('span', {
                  slot: 'close',
                  domProps: {
                    innerHTML: '下架'
                  }
                }),
              ])
            }
          },
          {
            title: '创建时间',
            key: 'createTime',
            width:130
          },
          {
            title: '操作',
            width:200,
            align:"center",
            render: (h, params) => {
              return h('div',
                {
                  style:{
                    display: "flex"
                  },
                },
                [h(CellBar,
                {
                  props:{
                    show:'text'  //操作也显示标准按钮的样式（text、icon、textIcon）
                  },

                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                  on: {
                    // 子组件$emit传递函数,必须是箭头函数写法
                    'edit': ()=> {
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'delete':()=>{
                      this.$nextTick(()=>{
                        this.paasDeleteOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    /**
                     * 属性配置
                     * */
                    'configProperty':()=>{
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName],this.serviceUrl+"/attr")
                      })
                    }
                  }
                }),/*h('Dropdown',[
                    h('Button',{
                      props:{
                        type:"primary",
                        size:"small"
                      },
                      style:{
                        padding:"2px 5px",
                        fontSize:"12px",
                        height:"24px",
                        borderRadius:"2px"

                      }
                    },[
                      h('span','操作'),
                      h('Icon',{
                        props:{
                          type:"ios-arrow-down"
                        }
                      })
                    ]),
                    h('DropdownMenu',{
                        slot:"list",
                    },[

                      h('DropdownItem',{
                        nativeOn:{
                          click:(name)=>{
                            this.$router.push({'path': this.setUrlFuncId("/eb/store/seckill/edit?id="+params.row.id)});
                          }
                        }
                      },[
                        h('Icon',{
                          props:{
                            type:"ios-alarm",
                            color:'rgb(43, 133, 228)'
                          },
                        }),h('span',' 开启秒杀'),
                      ]),
                      h('DropdownItem',[
                        h('Icon',{
                          props:{
                            type:"md-hammer",
                            color:'rgb(43, 133, 228)'
                          }
                        }),h('span',' 开启砍价'),
                      ]),
                      h('DropdownItem',[
                        h('Icon',{
                         props:{
                            type:"md-contacts",
                            color:'rgb(43, 133, 228)'
                          }
                        }),h('span',' 开启拼团'),
                      ]),
                      h('DropdownItem',[
                        h('Icon',{
                         props:{
                            type:"ios-trash",
                             color:'rgb(43, 133, 228)'
                          }
                        }),h('span',' 产品回收'),
                      ]),
                      h('DropdownItem',[
                        h('Icon',{
                          props:{
                            type:"logo-whatsapp",
                             color:'rgb(43, 133, 228)'
                          }
                        }),h('span',' 评论查看'),
                      ]),
                    ]),

                  ]
                )*/]
              )
            }
          }
        ],
        /**
         * 下拉树
         * */
        showfkaStoreCategoryNameTree:false,
      }
    },
    mounted(){
    },
    methods:{
      checkProduct(type){
        this.queryParam.query_LIKE_isShow = type;
        this.queryTableDatas();
      },
      /**
       * 显示节点下拉树
       */
      changefkaStoreCategoryNameFlag(){
        this.showfkaStoreCategoryNameTree = true;
      },
      updatefkaStoreCategoryNameTreeNode(node){
        this.queryParam.fkaStoreCategoryName = node.title;
        /*let childrenIds = node.id;
        for(let i = 0; i < node.children.length; i++){
          if(childrenIds) {
            childrenIds += "|";
          }
          childrenIds += node.children[i].id;
        }
        console.log(childrenIds);*/
        this.queryParam.query_LIKE_fkaStoreCategoryId = node.id;
        this.queryTableDatas();
        this.showfkaStoreCategoryNameTree = false;
      },
      handlefkaStoreCategoryNameClose(){
        this.showfkaStoreCategoryNameTree = false;
      },
      /**
       * 清除后查询
       */
      clearfkaStoreCategoryName(){
        this.queryParam.query_LIKE_fkaStoreCategoryId = "";
        this.queryTableDatas();
      },
      /**
       * 设置上下架数据
       */
      saveOnShowData(row){
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/saveOnShowData?isShow="+row.isShow+"&id="+row.id).then(res => {
          if(res.code === 200) {
            this.$Message.info('数据更新成功！');
          }
        }).catch(function(error){
          this.$Message.error('数据更新失败！');
        });
      }
    }
  }
</script>
<style scoped>
  .sale-status:after,.ivu-switch-checked:after{
    left:40px !important;
  }
</style>
